/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/**
 * This module provides access to firebase configuration and services for the frontend UI.
 *
 * Note that there are sections of configuration below which are filled in by scripts.
 * These are run manually during local testing, or by the deploy script during deployment.
 *
 * The exports are imported into front end code to provide access to Firebase Functions deployed in the cloud.
 * Any logging performed here will appear in the user's browser's JS console.
 * Note also that therefore we have no control over environment variables.
 */

// Import Firebase production app:
import firebase from 'firebase/app';
// Import the individual services that we will use in Firebase:
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';
import 'firebase/analytics';

console.log("firebase-init");

// Name of the Firebase app with access to ebx-core services
const FIREBASE_CORE_NAME = 'core';

// ----------------------------------------------------------------------------
// Firebase app configuration
// ----------------------------------------------------------------------------
// XXX This config section will be filled in by insertFirebaseConfig.sh
const firebaseConfig = {
  "projectId": "ee-unep",
  "appId": "1:523457504100:web:85d4ea5778d5dbdf9fd071",
  "databaseURL": "https://ee-unep.firebaseio.com",
  "storageBucket": "ee-unep.appspot.com",
  "locationId": "europe-west2",
  "apiKey": "AIzaSyCviLXPgSWhx9tjAUZJ-sy98b6aeGn9re0",
  "authDomain": "ee-unep.firebaseapp.com",
  "messagingSenderId": "523457504100",
  "measurementId": "G-GSM12TEH32"

};

// XXX This config section will be filled in by insertFirebaseConfig.sh
const firebaseCoreConfig = {
  "projectId": "ebx-core",
  "appId": "1:629678258428:web:9e56bf8665898a06983f79",
  "storageBucket": "ebx-core.appspot.com",
  "locationId": "europe-west2",
  "apiKey": "AIzaSyB6PuTvJ6koLP088rpSv4NbhrC46wvzmIs",
  "authDomain": "ebx-core.firebaseapp.com",
  "messagingSenderId": "629678258428",
  "measurementId": "G-HL5PCTYWDZ"

};

// XXX The value of the maps API key will be filled in by setMapsApiKey.sh
const mapsApiKey = 'AIzaSyCviLXPgSWhx9tjAUZJ-sy98b6aeGn9re0';

// Initialize Firebase apps
firebase.initializeApp(firebaseConfig);
const coreApp = firebase.initializeApp(firebaseCoreConfig, FIREBASE_CORE_NAME);

// ----------------------------------------------------------------------------
// Service references
// ----------------------------------------------------------------------------

// Project-specific services
const projectId = firebaseConfig.projectId;
const app = firebase.app();
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const EmailAuthProvider = firebase.auth.EmailAuthProvider;


// ----------------------------------------------------------------------------
// Environment setup
// ----------------------------------------------------------------------------
// - settings for LTI projects
// - use emulators in dev mode
// ----------------------------------------------------------------------------
// Is this an LTI-integrated project? Note we don't include UOE in this, which has a MOOC organisation but is primarily a normal install.
let requiresLTIIntegration = projectId==="ebx-mooc" || projectId==="eb-edina"; // || projectId==="ee-uoe";
console.debug(`firebase.js setup: projectId ${projectId} requiresLTIIntegration ${requiresLTIIntegration}`);
// If this is an LTI-integrated project, set auth persistence to none; otherwise Firebase tries
// to persist the auth info locally on the broswser, which requires third party cookies
// when running in an IFrame within FutureLearn. Session does not work with Node.js
// See https://firebase.google.com/docs/auth/web/auth-state-persistence
// if (requiresLTIIntegration) {
//     auth.setPersistence(firebase.auth.Auth.Persistence.NONE);
// }

// Use the db and auth emulators if in development mode
if (process.env.NODE_ENV==="development" || location.hostname === "localhost") {
    console.info("Localhost environment: Using firestore and auth emulators");
    db.useEmulator("localhost", 8080);
    auth.useEmulator("http://localhost:9099/");
    storage.useEmulator("localhost", 9199);
}


// Firestore collections
const earthbloxCollection = db.collection('earthblox')
const organisationsCollection = db.collection('organisations')

// EBX Core services
const coreDB = firebase.firestore(coreApp);
const coreStorage = firebase.storage(coreApp);


export {
    EmailAuthProvider,
    db,
    auth,
    app,
    earthbloxCollection,
    organisationsCollection,
    storage,
    firebaseConfig,
    mapsApiKey,
    // Export ebx-core services
    coreDB,
    coreStorage,
    projectId
}
